<template>
  <div class="section-abstract-header">Informations juridiques et affiliations</div>
  <div class="section-abstract mb-1">
    <v-row class="ma-0 abstract-row" @click="openSection('SectionEtablissementInformationJuridiqueExtend', 'etablissement', false)">
      <v-col>
        <div class="section-abstract-title">Informations juridiques</div>
        <div class="section-abstract-grid" style="display:grid; grid-template-columns: repeat(2, minmax(0, 1fr)); column-gap: 16px; row-gap: 0; align-items: start;">
          <div class="section-abstract-cell" style="grid-row: 1 / span 1; grid-column: 1 / span 1;">
            <div class="section-abstract-label pt-2">SIRET</div>
            <div class="section-abstract-value">{{ etablissement.siret }} <v-icon v-if="etablissement.siret" class="pl-2" color="rgb(var(--v-theme-secondary60))" size="14" @click.stop="copyText(etablissement.siret, 0)">{{ copiedField === 0 ? 'fas fa-check' : 'fas fa-copy' }}</v-icon></div>
          </div>
          <div class="section-abstract-cell" style="grid-row: 1 / span 1; grid-column: 2 / span 1;">
            <div class="section-abstract-label pt-2">Code APE</div>
            <div class="section-abstract-value">{{ etablissement.brancheCode }} <v-icon v-if="etablissement.brancheCode" class="pl-2" color="rgb(var(--v-theme-secondary60))" size="14" @click.stop="copyText(etablissement.brancheCode, 1)">{{ copiedField === 1 ? 'fas fa-check' : 'fas fa-copy' }}</v-icon></div>
          </div>
          <div class="section-abstract-cell" style="grid-row: 2 / span 1; grid-column: 1 / span 1;">
            <div class="section-abstract-label pt-2">Convention collective</div>
            <div class="section-abstract-value">{{ etablissement.conventionCode }} <v-icon v-if="etablissement.conventionCode" class="pl-2" color="rgb(var(--v-theme-secondary60))" size="14" @click.stop="copyText(etablissement.conventionCode, 2)">{{ copiedField === 2 ? 'fas fa-check' : 'fas fa-copy' }}</v-icon></div>
          </div>
          <div class="section-abstract-cell" style="grid-row: 2 / span 1; grid-column: 2 / span 1;">
            <div class="section-abstract-label pt-2">Licence entrepreneur spectacle vivant </div>
            <div class="section-abstract-value">{{ etablissement.licenceSpectacle }} <v-icon v-if="etablissement.licenceSpectacle" class="pl-2" color="rgb(var(--v-theme-secondary60))" size="14" @click.stop="copyText(etablissement.licenceSpectacle, 3)">{{ copiedField === 3 ? 'fas fa-check' : 'fas fa-copy' }}</v-icon></div>
          </div>
        </div>
      </v-col>
      <v-col cols="1" class="align-content-center align-items-center">
        <v-icon class="chevron-right">
          fas fa-chevron-right
        </v-icon>
      </v-col>
    </v-row>
    <v-row class="ma-0 abstract-row" @click="openSection('SectionEtablissementAffliationExtend', 'etablissement', false)">
      <v-col>
        <div class="section-abstract-title">Affiliations</div>
        <div class="section-abstract-grid" style="display:grid; grid-template-columns: repeat(2, minmax(0, 1fr)); column-gap: 16px; row-gap: 0; align-items: start;">
          <div class="section-abstract-cell" style="grid-row: 1 / span 1; grid-column: 1 / span 1;">
            <div class="section-abstract-label pt-2">N° URSSAF</div>
            <div class="section-abstract-value">{{ etablissement.urssaf }} <v-icon v-if="etablissement.urssaf" class="pl-2" color="rgb(var(--v-theme-secondary60))" size="14" @click.stop="copyText(etablissement.urssaf, 4)">{{ copiedField === 4 ? 'fas fa-check' : 'fas fa-copy' }}</v-icon></div>
          </div>
          <div class="section-abstract-cell" style="grid-row: 1 / span 1; grid-column: 2 / span 1;">
            <div class="section-abstract-label pt-2">N° Congés Spectacle</div>
            <div class="section-abstract-value">{{ etablissement.congesSpec }} <v-icon v-if="etablissement.congesSpec" class="pl-2" color="rgb(var(--v-theme-secondary60))" size="14" @click.stop="copyText(etablissement.congesSpec, 5)">{{ copiedField === 5 ? 'fas fa-check' : 'fas fa-copy' }}</v-icon></div>
          </div>
          <div class="section-abstract-cell" style="grid-row: 2 / span 1; grid-column: 1 / span 1;">
            <div class="section-abstract-label pt-2">N° Affiliation France Travail</div>
            <div class="section-abstract-value">{{ etablissement.poleEmploiAffiliation }} <v-icon v-if="etablissement.poleEmploiAffiliation" class="pl-2" color="rgb(var(--v-theme-secondary60))" size="14" @click.stop="copyText(etablissement.poleEmploiAffiliation, 6)">{{ copiedField === 6 ? 'fas fa-check' : 'fas fa-copy' }}</v-icon></div>
          </div>
          <div class="section-abstract-cell" style="grid-row: 2 / span 1; grid-column: 2 / span 1;">
            <div class="section-abstract-label pt-2">Caisse de retraite complémentaire</div>
            <div class="section-abstract-value">{{ etablissement.retraiteComplementaireNom }} <v-icon v-if="etablissement.retraiteComplementaireNom" class="pl-2" color="rgb(var(--v-theme-secondary60))" size="14" @click.stop="copyText(etablissement.retraiteComplementaireNom, 7)">{{ copiedField === 7 ? 'fas fa-check' : 'fas fa-copy' }}</v-icon></div>
          </div>
        </div>
      </v-col>
      <v-col cols="1" class="align-content-center align-items-center">
        <v-icon class="chevron-right">
          fas fa-chevron-right
        </v-icon>
      </v-col>
    </v-row>
  </div>
</template>

<script lang="ts">
  import {defineAsyncComponent, defineComponent, markRaw, type PropType} from "vue";
  import CrudEtablissement from '@/generated/cruds/CrudEtablissement';
  // eslint-disable-next-line
  import { GenControl, GenSection, RessourceGenControl, RessourceGenSection } from '@/generated/ressources/generatedRessources';
  import { FwkButtons, RessourceFwkButton, RessourceFwkSection, FwkSections } from '@/ressources/globalRessources';
  import {Fiches, Modules, Sections} from '@/generated/classes/AppSchema';
  import Button, { ButtonCallback } from '@/framework/base/classes/Button';
  import Owner from '@/extend/classes/Owner';
  import { ObjTypes } from '@/generated/classes/ObjTypes';
  import Route from "@/generated/classes/Route.ts";
  import Section from '@/framework/base/classes/Section';
  import {getSection} from "@/framework/base/helpers/ComponentFinder.ts";

  export default defineComponent({
    extends:  CrudEtablissement,
    components: {},
    props: {
      hideTitle: {
        type: Boolean,
      },
    },

    data() {
      return {
        sectionName: Sections.ETABLISSEMENT_JURIDIQUE_ABSTRACT,
        displayMap: new Map<string, Boolean>,
        readOnlyMap: new Map<string, Boolean>,
        requiredMap: new Map<string, Boolean>,
        copiedField: null as number | null,
      }
    },

    computed: {
      saveLabel () { 
        return RessourceFwkButton(FwkButtons.ENREGISTRER).label;
      },

      errorTxt () { 
        return RessourceFwkSection(FwkSections.ERROR_TEXT).label;
      },


      ressource () { return RessourceGenSection(GenSection.ETABLISSEMENT_JURIDIQUE_ABSTRACT); },

    },
    methods: {
      getRequiredAttributs(): string[] {
        const res: string[] = [];
        if (this.requiredAttributs) {
          this.requiredAttributs.forEach((attrib) => {
            const value = attrib.split(".");
            if (value[0] == this.sectionName) {
              res.push(value[1])
            }
          })
        }
        return res;
      },

      openSection(componentName: string, objType: string, isList = false): void {
        const route = new Route();
        const section  = new Section();
        const loader = getSection(componentName);
        let component = null;
        if (loader) {
          component = markRaw(defineAsyncComponent(loader as any));
        }
        if (isList) {
          route.module = Modules.ETABLISSEMENT;
          route.fiche = Fiches.CONTAINER;
          route.ficheHeader = this.headerTitle();
          if (component) {
            section.component = component;
          }
          section.propType = objType;
          section.propData = this.etablissement;
          route.data = section;
        }
        this.$emit('openSection', component, route, isList);
      },

      headerTitle(): string {
        return ""
      },

      requiredMissing(requiredAttributs: string[], value: string): boolean {
        return requiredAttributs.length > 0 && requiredAttributs.includes(value);
      },

      readOnly (value: string): boolean {
        let res = false;
        if (!this.editEtablissement.canUpdate) {
          return true;
        }
        if (this.readOnlyMap.size == 0) {
        }
        const readOnly = this.readOnlyMap.get(value);
        if (readOnly != undefined) {
          res = readOnly;
        }
        return res;
      },

      isDisplayed (value: string): boolean {
        let res = true;
        if (this.displayMap.size == 0) {
        const requiredAttributs = this.getRequiredAttributs();
        }
        const display = this.displayMap.get(value);
        if (display != undefined) {
          res = display;
        }
        return res;
      },

      isRequired (value: string): boolean {
        let res = true;
        const requiredAttributs = this.getRequiredAttributs();
        if (this.requiredMap.size == 0) {
        }
        const required = this.requiredMap.get(value);
        if (required != undefined) {
          res = required;
        }
        return res;
      },

      picto (): string {
        return 'SectionPictoAbstract' 
      },

      sectionSave (): void {
        return this.save();
      },
      copyText(text: string, fieldIndex: number): void {
        const textToCopy = text.trim();
        navigator.clipboard.writeText(textToCopy).then(() => {
          this.copiedField = fieldIndex;
          setTimeout(() => this.copiedField = null, 1500);
        }).catch((err) => {
          console.error('Failed to copy:', err);
        });
      }
    }
  })
</script>
